import {
    EMPLOYEE_LIST,
    EMPLOYEE_LIST_SUCCESS,
    EMPLOYEE_LIST_ERROR,
    EMPLOYEE_PAGE_SET,
    EMPLOYEE_DETAIL,
    EMPLOYEE_DETAIL_SUCCESS,
    EMPLOYEE_DETAIL_ERROR,
    EMPLOYEE_VIEW_MODAL_SET,
    EMPLOYEE_ADD_MODAL_SET,
    EMPLOYEE_ADD,
    EMPLOYEE_ADD_SUCCESS,
    EMPLOYEE_ADD_ERROR,
    EMPLOYEE_ADD_CHANGE,
    EMPLOYEE_EDIT_MODAL_SET,
    EMPLOYEE_EDIT_SET,
    EMPLOYEE_EDIT_CHANGE,
    EMPLOYEE_UPDATE,
    EMPLOYEE_UPDATE_SUCCESS,
    EMPLOYEE_UPDATE_ERROR
} from '../actions';

const INIT_STATE = {
    loading: true,
    error: false,
    list: {
        page: { current: 1, rows: 10 },
        data: [],
        total_pages: 0,
        total_item: 0,
        first_page: 0,
        last_items: 0
    },
    detail: {
        data: {},
        loading: false
    },
    view: {
        modal: false
    },
    add: {
        modal: false,
        loading: false,
        id: null,
        data: {
            new: {
                name: '',
                code: '',
                email: '',
                phone: ''
            }
        }
    },
    edit: {
        modal: false,
        loading: false,
        data: {}
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case EMPLOYEE_LIST:
            return { ...state, loading: true };
        case EMPLOYEE_LIST_SUCCESS:
            return { ...state, loading: false, list: { ...state.list, ...action.payload } };
        case EMPLOYEE_LIST_ERROR:
            return { ...state, loading: false, error: true };
        case EMPLOYEE_PAGE_SET:
            return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
        case EMPLOYEE_DETAIL:
            return { ...state, detail: { ...state.detail, loading: true, data: {} } };
        case EMPLOYEE_DETAIL_SUCCESS:
            return { ...state, detail: { ...state.detail, loading: false, data: action.payload } };
        case EMPLOYEE_DETAIL_ERROR:
            return { ...state, detail: { ...state.detail, loading: false, data: {} } };
        case EMPLOYEE_VIEW_MODAL_SET:
            return { ...state, view: { ...state.view, modal: action.payload } };
        case EMPLOYEE_ADD_MODAL_SET:
            return { ...state, add: { ...state.add, modal: action.payload } };
        case EMPLOYEE_ADD:
            return { ...state, add: { ...state.add, loading: true } };
        case EMPLOYEE_ADD_SUCCESS:
            return { ...state, add: { ...state.add, loading: false, id: action.payload, data: { new: { name: '', code: '', email: '', phone: '' } } } };
        case EMPLOYEE_ADD_ERROR:
            return { ...state, add: { ...state.add, loading: false } };
        case EMPLOYEE_ADD_CHANGE:
            return { ...state, add: { ...state.add, data: { new: { ...state.add.data.new, ...action.payload } } } };
        case EMPLOYEE_EDIT_MODAL_SET:
            return { ...state, edit: { ...state.edit, modal: action.payload } };
        case EMPLOYEE_EDIT_SET:
            return { ...state, edit: { ...state.edit, data: action.payload } };
        case EMPLOYEE_EDIT_CHANGE:
            return { ...state, edit: { ...state.edit, data: { ...state.edit.data, ...action.payload } } };
        case EMPLOYEE_UPDATE:
            return { ...state, edit: { ...state.edit, loading: true } };
        case EMPLOYEE_UPDATE_SUCCESS:
            return { ...state, edit: { ...state.edit, loading: false, modal: false } };
        case EMPLOYEE_UPDATE_ERROR:
            return { ...state, edit: { ...state.edit, loading: false } };
        default:
            return state;
    }
};
